module.exports = __webpack_public_path__ + "assets/fonts/check-1.696e7d90.svg";